import { Document, Page, pdfjs } from "react-pdf";
import { useState } from "react";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

// ✅ CRA-SAFE, NON-ESM WORKER
pdfjs.GlobalWorkerOptions.workerSrc =
  `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PdfUrlView = ({ doc, height = "100%" }) => {
  const [numPages, setNumPages] = useState(null); 
  if (!doc) return null;

  return (
    <div style={{ height, overflow: "auto" }}>
      <Document
        file={doc}
        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
        loading={<p style={{ textAlign: "center" }}>Loading PDF…</p>}
        error={
          <p style={{ textAlign: "center", color: "red" }}>
            Failed to load PDF
          </p>
        }
      >
        {Array.from(new Array(numPages), (_, i) => (
          <Page
            key={i}
            pageNumber={i + 1}
            width={900}
          />
        ))}
      </Document>
    </div>
  );
};

export default PdfUrlView;
